/**
 * Image Cache Service - Web Version
 *
 * On web, we don't use local file system caching.
 * The browser's built-in cache handles image caching efficiently.
 * This service simply returns the original URLs.
 */
import { ImageCacheStats, CachedImageResult } from '@/types';

class ImageCacheService {
  private initialized = false;
  private memoryCache: Map<string, string> = new Map();

  async initialize(userId?: string): Promise<void> {
    if (this.initialized) {
      return;
    }
    console.log('[IMAGE-CACHE] Web: Using browser cache (no local file system)');
    this.initialized = true;
  }

  async getCachedImageUri(
    thumbnailUrl: string,
    seriesId: string,
    autoDownload = true
  ): Promise<CachedImageResult> {
    if (!thumbnailUrl) {
      return {
        uri: '',
        isCached: false,
        isExpired: false,
        needsDownload: false,
      };
    }

    return {
      uri: thumbnailUrl,
      isCached: false,
      isExpired: false,
      needsDownload: false,
    };
  }

  async downloadAndCacheImage(thumbnailUrl: string, seriesId: string): Promise<string> {
    return thumbnailUrl;
  }

  async batchDownloadImages(items: Array<{ url: string; seriesId: string }>): Promise<void> {
    // No-op on web - browser handles caching
  }

  async getCacheStats(): Promise<ImageCacheStats> {
    return {
      totalImages: 0,
      totalSizeBytes: 0,
      totalSizeMB: 0,
      oldestCacheDate: null,
      newestCacheDate: null,
      expiredCount: 0,
    };
  }

  async clearExpiredCache(): Promise<number> {
    return 0;
  }

  async clearAllCache(): Promise<number> {
    this.memoryCache.clear();
    return 0;
  }

  isInitialized(): boolean {
    return this.initialized;
  }
}

export const imageCacheService = new ImageCacheService();
